import React, { useState, useEffect } from "react";
import { getPartyBill } from "../../../api/endpoints/allReports.js";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import SideBar from "../../sidebar/sideBar.js";
import { getAllPartySearch } from "../../../api/endpoints/search.js";
import { Button, Dropdown, Select, Menu } from "antd";
import Header from "../../header/header.jsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getSiteRefrence } from "../../../api/endpoints/refrences";
const { Option } = Select;


const PartyBill = () => {
  const { access_token } = useSelector(authSelector);
  const [enteredOn, setEnteredOn] = useState("");
    const [siteName, setSiteName] = useState();
    const [siteAddress, setSiteAddress] = useState();

  const [state, setState] = useState({
    parties: [],
    partyId: "", //ac no.
    partyName: "", // supplier name
    enteredOn: "",
    reportType: "0",
    startingDate: "",
  });

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  console.log(state, "Stateeeeee");
  const [itemsQueue, setItemsQueue] = useState([]);

   function formatDate(inputDate) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      const formattedDate = new Date(inputDate).toLocaleDateString(
        undefined,
        options
      );
      return formattedDate;
    }
    const formatDateDDMMYYYY = (dateStr) => {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      const day = d.getDate();
      const month = d.getMonth() + 1; // months are 0-based
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    };
    const getName = async (e) => {
      const result = await getSiteRefrence(access_token);
      if (result.success) {
        setSiteName(result.data.siteName);
        setSiteAddress(result.data.siteAddress);
      } else {
        message.error(result.message);
      }
    };

  const getAllData = async () => {
    const _parties = await getAllPartySearch(access_token);

    setState({
      ...state,
      parties: _parties,
    });
  };
  useEffect(() => {
    getAllData();
getName()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    const [loading, setLoading] = useState(false);
  const editHandler = async (e) => {
    if (!state.enteredOn) return message.error("Please type Ending date !");
    if (!state.startingDate)
      return message.error("Please type Starting date !");
    if (!state.partyId) return message.error("Please type Party Id !");
    let data = {
      startingDate: state.startingDate,
      enteredOn: state.enteredOn,
      partyId: state.partyId,
      reportType: Number(state.reportType),
    };
     try {
      setLoading(true); // disable button
    const results = await getPartyBill(data, access_token);
    console.log(results.data.length, "ressaaaaa");
    if (results.data.length === 0) {
      message.error("No Record Found in these date");
    }
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            enteredOn: curr.enteredOn,
            partyId: Number(curr.partyId),
            vehicalId: Number(curr.vehicalId),
            regNumber: curr.regNumber,
            partyName: curr.partyName,
            couponNo: Number(curr.couponNo),
            itemCode: curr.itemCode,
            itemName: curr.itemName,
            saleRate: Number(curr.saleRate),
            quantity: Number(curr.quantity),
            amount: Number(curr.amount),
            siteId: curr.siteId,
          },
        ];
      }, []);
      setItemsQueue(payload);
        generatePDF(payload);
    } else {
      message.error(results.message);
    }}catch (err) {
          message.error("Something went wrong!");
          console.error(err);
        } finally {
          setLoading(false); // re-enable button
        }
  };

  const clearState = () => {
    setItemsQueue([]);
  };
const generatePDF = (data) => {
  if (!data || data.length === 0) {
    message.error("No data to generate report!");
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");
  const now = new Date();
  const printDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

  // ===== Group by vehicleId =====
  const groupedByVehicle = data.reduce((acc, row) => {
    if (!acc[row.vehicalId]) acc[row.vehicalId] = [];
    acc[row.vehicalId].push(row);
    return acc;
  }, {});

  Object.keys(groupedByVehicle).forEach((vehicalId, index) => {
    const vehicleEntries = groupedByVehicle[vehicalId];

    // Sort entries by date
    vehicleEntries.sort(
      (a, b) => new Date(a.enteredOn) - new Date(b.enteredOn)
    );

    // ========== HEADER ==========
    doc.setFontSize(8);
    doc.text(`Printed on: ${printDateTime}`, 200, 5, { align: "right" });
    doc.setFontSize(16);
    doc.text(siteName, 105, 11, { align: "center" });
    doc.setFontSize(12);
    doc.text(siteAddress, 105, 16, { align: "center" });
    doc.setFontSize(11);
    doc.text(
      `Credit Bill From ${state.startingDate} To ${state.enteredOn}`,
      105,
      23,
      { align: "center" }
    );
    doc.setFontSize(11);
    doc.text(`Party: ${state.partyName}`, 14, 32);
    doc.text(
      `Vehicle: ${vehicleEntries[0]?.regNumber || ""}`,
      170,
      32,
      { align: "left" }
    );

    // ========== MAIN TABLE ==========
    const tableRows = vehicleEntries.map((r) => [
      r.enteredOn ? formatDateDDMMYYYY(r.enteredOn) : "",
      r.regNumber || "",
      r.itemName || "",
      r.couponNo || "",
      r.saleRate.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      r.quantity.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      r.amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    ]);

    const totalQty = vehicleEntries.reduce(
      (sum, r) => sum + (Number(r.quantity) || 0),
      0
    );
    const totalAmount = vehicleEntries.reduce(
      (sum, r) => sum + (Number(r.amount) || 0),
      0
    );

    // Add totals row at bottom
    tableRows.push([
      "",
      "",
      "",
      "Total",
      "",
      totalQty.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      totalAmount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    ]);

    autoTable(doc, {
      head: [["Date", "Vehicle", "Item", "Coupon", "Rate", "Qty", "Amount"]],
      body: tableRows,
      startY: 35,
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 1,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 20 }, // Date
        1: { halign: "center", cellWidth: 30 }, // Vehicle
        2: { halign: "left", cellWidth: 40 }, // Item
        3: { halign: "center", cellWidth: 25 }, // Coupon
        4: { halign: "right", cellWidth: 20 }, // Rate
        5: { halign: "right", cellWidth: 25 }, // Qty
        6: { halign: "right", cellWidth: 30 }, // Amount
      },
      didParseCell: (data) => {
        if (data.row.index === tableRows.length - 1) {
          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    // ========== ITEM SUMMARY TABLE ==========
    const itemWiseTotals = vehicleEntries.reduce((acc, curr) => {
      if (!acc[curr.itemCode]) {
        acc[curr.itemCode] = {
          itemName: curr.itemName,
          qty: 0,
          amt: 0,
        };
      }
      acc[curr.itemCode].qty += Number(curr.quantity) || 0;
      acc[curr.itemCode].amt += Number(curr.amount) || 0;
      return acc;
    }, {});

    const summaryRows = Object.values(itemWiseTotals).map((tot) => [
      tot.itemName,
      vehicleEntries[0]?.regNumber || "",
      tot.qty.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      tot.amt.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    ]);

    // Summary totals
    summaryRows.push([
      "Total",
      "",
      totalQty.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      totalAmount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    ]);

    // autoTable(doc, {
    //   head: [["Item", "Vehicle", "Qty", "Amount"]],
    //   body: summaryRows,
    //   startY: doc.lastAutoTable.finalY + 5,
    //   theme: "grid",
    //   styles: { fontSize: 9, cellPadding: 1 },
    //   headStyles: {
    //     fillColor: [255, 255, 255],
    //     textColor: [0, 0, 0],
    //     fontStyle: "bold",
    //     halign: "center",
    //   },
    //   columnStyles: {
    //     0: { halign: "left", cellWidth: 60 }, // Item
    //     1: { halign: "center", cellWidth: 40 }, // Vehicle
    //     2: { halign: "right", cellWidth: 40 }, // Qty
    //     3: { halign: "right", cellWidth: 50 }, // Amount
    //   },
    //   didParseCell: (data) => {
    //     if (data.row.index === summaryRows.length - 1) {
    //       data.cell.styles.fontStyle = "bold";
    //     }
    //   },
    // });
    autoTable(doc, {
  head: [["Item", "Vehicle", "Qty", "Amount"]],
  body: summaryRows,
  startY: doc.lastAutoTable.finalY + 5,
  theme: "grid",
  styles: {
    fontSize: 9,
    cellPadding: 1,
    textColor: [0, 0, 0],   // ✅ black text
    lineColor: [0, 0, 0],   // ✅ black border
    lineWidth: 0.5,
  },
  headStyles: {
    fillColor: [255, 255, 255],
    textColor: [0, 0, 0],   // ✅ black text
    fontStyle: "bold",
    halign: "center",
    lineColor: [0, 0, 0],   // ✅ black border
    lineWidth: 0.5,
  },
  columnStyles: {
    0: { halign: "left", cellWidth: 60 },   // Item
    1: { halign: "center", cellWidth: 40 }, // Vehicle
    2: { halign: "right", cellWidth: 40 },  // Qty
    3: { halign: "right", cellWidth: 50 },  // Amount
  },
  didParseCell: (data) => {
    if (data.row.index === summaryRows.length - 1) {
      data.cell.styles.fontStyle = "bold";
    }
  },
});

    // New page for next vehicle
    if (index < Object.keys(groupedByVehicle).length - 1) {
      doc.addPage();
    }
  });

  // ====== Open in new tab ======
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
};


  return (
    <>
   
          <div className="flex  bg-black main">
            <SideBar />
            <div className="h-full  flex flex-col content-center  w-full">
              <Header />
              <div className="flex justify-center mt-10">
                <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
                  <div className="bg-blue-500 headingBox flex justify-center">
                    <h1 className=" text-white">Party Bill</h1>
                  </div>
                  <div className="flex flex-col  h-40 content-center items-center justify-items-center justify-evenly">
                    <div>
                      <label className="text-white" for="fname">
                        Starting Date:
                      </label>
                      <input
                        type="date"
                        name="startingDate"
                        value={state.startingDate}
                        onChange={onChangeText}
                        className="bg-black dateInp text-white  inpTxt  mt-5 p-1 h-9 ml-3"
                      />
                      <label className="text-white ml-2" for="fname">
                        Ending Date:
                      </label>
                      <input
                        type="date"
                        name="enteredOn"
                        value={state.enteredOn}
                        onChange={onChangeText}
                        className="bg-black dateInp text-white  inpTxt  mt-5 p-1 h-9 ml-3"
                      />
                    </div>
                    <div className="flex">
                  <div>
                    <label className="text-white ml-2 mr-2" for="fname">
                      Account:
                    </label>
                    <Select
                      showSearch
                      style={{
                        cursor: "pointer !important",
                        background: "red !important",
                      }}
                      name="partyId"
                      placeholder="A/C No."
                      // className=" custom-select ant-select bg-black text-white inpTxt mt-5 p-1 h-9 w-64"
                      className="ant-select-item-option-active bg-black text-white  mt-5 h-9  w-64"
                      optionFilterProp="children"
                      value={state.partyId || "A/C No."}
                      onChange={(e) => {
                        console.log("e", e);

                        const _party = state.parties.find(
                          (el) => el.partyId === e
                        );
                        if (_party) {
                          setState({
                            ...state,
                            partyId: e,
                            partyName: _party.PartyName,
                          });
                        } else {
                          setState({
                            ...state,
                            partyId: e,
                            partyName: "",
                          });
                        }
                      }}
                    >
                      <Option value={0}>None</Option>
                      {state.parties.map((el) => (
                        <Option
                          className="w-auto"
                          value={el.partyId}
                        >{`${el.partyId} - ${el.PartyName}`}</Option>
                      ))}
                    </Select>
                  </div>

                  <div>
                    <label className="text-white mt-5 ml-2 mr-2">
                      Report Type:
                    </label>
                    <Select
                      className="mt-5 ml-2 w-40"
                      value={state.reportType}
                      onChange={(value) =>
                        setState({ ...state, reportType: value })
                      }
                    >
                      <Option value="0">EnteredOn Wise</Option>
                      <Option value="1">Slip Date Wise</Option>
                    </Select>
                  </div>
                </div>
                    <div>
                      <button
                    className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-blue-700"
                    }`}
                    onClick={editHandler}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "View"}
                  </button>
                      <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded">
                        clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    </>
  );
};

export default PartyBill;
